import { PageHeader } from "@/components/PageHeader";
import { PeriodSelector } from "@/components/PeriodSelector";
import { SearchIcon } from "@chakra-ui/icons";
import { Grid, Input, InputGroup, InputLeftElement } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { FunctionComponent, ReactEventHandler } from "react";

interface HeaderLayoutProps {
    title: string
    breadcrumbActived?: boolean
    calendarInput?: boolean
    searchInput?: boolean
    functionInput?: ReactEventHandler<InputEvent>
    icon?: React.ReactNode
}

const HeaderLayout: FunctionComponent<HeaderLayoutProps> = ({ title, breadcrumbActived = false, calendarInput, functionInput, searchInput, icon }) => {

    return (
        <>
            <PageHeader 
                title={title} 
                breadcrumb={
                    <>
                        {breadcrumbActived ? <Hei /> : <Hei />}
                    </>
                } 
                icon={icon}
            >
                <Grid gap={1}>
                    {calendarInput && <PeriodSelector />}

                    {
                        searchInput && (
                            <InputGroup>
                                <InputLeftElement h={'30px'}>
                                    <SearchIcon />
                                </InputLeftElement>

                                <Input
                                    placeholder="Pesquisa"
                                    w={'260px'}
                                    h={"30px"}
                                />
                            </InputGroup>
                        )
                    }
                </Grid>
            </PageHeader>
        </>
    );
}

export default HeaderLayout;

const Hei = styled.div`
    height: 10px
`;